// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__1NZaU","blue":"style_blue__38Yf3","orange":"style_orange__Y2a8Y","green":"style_green__3x-bZ","red":"style_red__1Qww1","gray":"style_gray__eCork"};